class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resultsContainer = this.querySelector('.search-results');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    // Aggiungi un event listener al documento per gestire i clic fuori dal box dei risultati
    document.addEventListener('click', (event) => {
      // Verifica se il clic è avvenuto all'interno del box dei risultati
      const isClickedInsideResults = this.resultsContainer.contains(event.target);
      // Se il clic non è avvenuto all'interno del box dei risultati, chiudi il box
      if (!isClickedInsideResults) {
        this.close();
      }
    });
    
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    this.resultsContainer.style.display = 'block';
  }

  close() {
    this.resultsContainer.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('search-form', PredictiveSearch);
